import {
  FourButtonLinkThemeInterface,
  FOUR_BUTTON_LINK_THEME,
} from '@thg-commerce/enterprise-widget-button-collection/theme'
import {
  EditorialItemTheme,
  EditorialItemThemeInterface,
} from '@thg-commerce/enterprise-widget-editorial/theme'
import {
  ImageTextBlockTheme,
  ImageTextBlockThemeInterface,
} from '@thg-commerce/enterprise-widget-image-text-block/theme'
import {
  ReferralStepGuideTheme,
  ReferralStepGuideInterface,
} from '@thg-commerce/enterprise-widget-referral-step-guide/theme'
import {
  DEFAULT_PRODUCT_LIST_WIDGET_THEME,
  ProductListThemeInterface,
} from '@thg-commerce/enterprise-widget-product-list-page/theme'
import {
  IMAGE_CARD_SET_DEFAULT_THEME,
  ImageCardSetThemeInterface,
} from '@thg-commerce/enterprise-widget-image-card-set/theme'
import {
  TabbedSetThemeInterface,
  TABBED_SET_WIDGET_THEME,
} from '@thg-commerce/enterprise-widget-tabbed-set/theme'
import {
  BestSellersThemeInterface,
  BEST_SELLERS_WIDGET_THEME,
} from '@thg-commerce/enterprise-widget-best-sellers/theme'

export type WidgetInterface = {
  imageTextBlock: ImageTextBlockThemeInterface
  referralStepGuide: ReferralStepGuideInterface
  productList: ProductListThemeInterface
  fourButtonLink: FourButtonLinkThemeInterface
  editorialItem: EditorialItemThemeInterface
  imageCardSet: ImageCardSetThemeInterface
  tabbedSet: TabbedSetThemeInterface
  bestSellers: BestSellersThemeInterface
}

export type WidgetThemeInterface = {
  widget: WidgetInterface
}

export const WidgetTheme: WidgetThemeInterface = {
  widget: {
    imageTextBlock: ImageTextBlockTheme,
    referralStepGuide: ReferralStepGuideTheme,
    productList: DEFAULT_PRODUCT_LIST_WIDGET_THEME,
    fourButtonLink: FOUR_BUTTON_LINK_THEME,
    editorialItem: EditorialItemTheme,
    imageCardSet: IMAGE_CARD_SET_DEFAULT_THEME,
    tabbedSet: TABBED_SET_WIDGET_THEME,
    bestSellers: BEST_SELLERS_WIDGET_THEME,
  },
}
